export enum Estate{
    Noting = 0,
    Saving = 1,
    Save   = 2,
    Error  = 3
}

export enum EarticleType{
    Service   = 0,
    Bike      = 1,
    Accessory = 2
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/utils/enum.util.ts